<template>
  <CollapsableSection
    v-if="item.state === $options.staged"
    :collapse="isCollapsed"
    :title="$options.title"
    @toggleCollapse="triggerResourceSummaryToggleExpanded"
  >
    <UserGroupsList
      :class="$style.resourceList"
      data-test-id="UserResources__UserGroupsList"
      @changeTab="navigateToTab"
    />
    <DevicesList
      :class="$style.resourceList"
      data-test-id="UserResources__DevicesList"
      @changeTab="navigateToTab"
    />
    <DirectoriesList
      :class="$style.resourceList"
      data-test-id="UserResources__DirectoriesList"
      @changeTab="navigateToTab"
    />
    <LdapList
      :class="$style.resourceList"
      data-test-id="UserResources__LdapList"
      @changeTab="navigateToTab"
    />
  </CollapsableSection>
</template>

<script>

import { eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';

import { ModuleConsts } from 'client/util/Constants';
import { mapState } from 'vuex';
import CollapsableSection from 'components/ContentSection/CollapsableSection.vue';
import DevicesList from './DevicesList.vue';
import DirectoriesList from './DirectoriesList.vue';
import LdapList from './LdapList.vue';
import UserGroupsList from './UserGroupsList.vue';

const { staged } = ModuleConsts.systemUser.accountStates;
const systemUserModel = 'SystemUserModel';
const {
  description,
  location,
  text,
  section,
} = eventProperties;

export default {
  name: 'UserResources',

  components: {
    CollapsableSection,
    DevicesList,
    DirectoriesList,
    LdapList,
    UserGroupsList,
  },

  data: () => ({
    isCollapsed: true,
  }),

  EventHelper,
  staged,

  title: 'Resource Summary',

  computed: {
    ...mapState(systemUserModel, ['item']),
  },

  methods: {
    navigateToTab(tabLabel) {
      this.$emit('changeTab', tabLabel);
    },

    triggerResourceSummaryToggleExpanded() {
      if (this.isCollapsed) {
        this.$options.EventHelper.triggerToggleClicked({
          [description]: 'Resource Summary Section Expanded',
          [location]: 'Users Aside Panel',
          [section]: 'Details Tab',
          [text]: 'Resource Summary',
        });
      }
      this.isCollapsed = !this.isCollapsed;
    },

  },
};
</script>

<style module scoped>
.resourceList:not(:last-child) {
  margin-bottom: var(--jc-spacer-medium);
}
</style>
